<template>
  <el-dialog title="任务执行人" :visible.sync="visible" width="70%" center :close-on-click-modal="false">
    <div class="select-box" v-if="visible">
      <div class="box-left fl">
        <el-input style="width:326px;" v-model="filterText" class="mt15" placeholder="请输入企业名称"></el-input>
        <p style="margin:8px 0;" class="fontC-bbb">执行企业</p>
        <el-tree
          class="filter-tree"
          :data="areaData"
          :props="defaultProps"
          :show-checkbox="true"
          node-key="parentKey"
          :filter-node-method="filterNodeDep"
          ref="treeDep"
          @check-change="handleNodeClickPerson"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <img v-if="data.key!='ALL'" src="../../../assets/images/ico_ora.png" alt="" />
            <div style="max-width:300px;overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;">{{ data.name }}</div>
          </div>
        </el-tree>
      </div>
      <div class="box-right fr">
        <p class="fontC-bbb fl">已选{{ departmentTableData.length }}个成员</p>
        <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
          >批量删除
        </el-button>
        <el-table
          :data="departmentTableData"
          border
          height="280px"
          style="width: 100%"
          @selection-change="handleSelectionChangeDel"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column header-align="center" align="center" show-overflow-tooltip prop="name" label="名称">
            <template slot-scope="scope">
            {{ scope.row.tenantTag }}（合计：{{scope.row.desc||0  }}人）
          </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer t-right">
      <el-button plain size="medium" @click="visible = false">取消</el-button>
      <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { debounce } from '@/uilt/tool.js'
export default {
  props:['belongStaffGuidList'],
  data() {
    return {
      defaultProps: {
        id: 'parentKey',
        label: 'name',
        children: 'child',
      },

      visible: false, //部门人员弹框
      defaultCheckedKeys: [],
      area: [],
      departmentList: [], //选中的部门人员数据
      departmentTableData: [], //选中的部门人员数据表格
      departmentData: '',
      areaData: [], //人员部门数据
      delList: [],
      personGuidList: [], //选中的人员guid
      filterText: '',
      fullscreenLoading: false,
      flag:false
    };
  },
  watch: {
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
    departmentList:{
      handler: debounce(function(data) {
        if (Array.isArray(data) && data.length) {
          console.log('触发');
          sessionStorage.setItem('selectNode',JSON.stringify(data))
          let tenantGuidList = data.map(item=>item.key || item.guid)
          this.getNumPeople(tenantGuidList)
        } else {
          this.departmentTableData = []
        }
      }, 0),
      immediate: false,
      deep: false
    }
  },
  created() {
  },
  methods: {
    open(personGuidList) {
      this.personGuidList = personGuidList; // 返显用
      this.visible = true;
      // this.getOrganisation();
      this.getOrganisation2();
    },

    //获取组织
    getOrganisation() {
      let self = this;
      let belongStaffGuidList = this.belongStaffGuidList;
      let newList = [];
      belongStaffGuidList.forEach(item=>{
        newList.push(item.guid)
      })
      let query = {
        "memberStatus": "ZSHY",
        "searchCode": "A001",
        "belongStaffGuidList":newList
      }
      self.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/get-all-send-tenant-simple-info`,query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            if(!self.areaData) return this.$message.error('暂无可选任务执行人，请检查项目运营人员')
            if (self.areaData.length > 0) {
              self.areaData.unshift({
                desc: 'ALL',
                guid: 'ALL',
                name: '全选'
              })
            }
            this.$nextTick(() => {
              if(this.personGuidList.length==this.areaData.length-1){
                this.personGuidList.push('ALL');
              }
              this.$refs.treeDep.setCheckedKeys(this.personGuidList);
              this.departmentList = this.$refs.treeDep.getCheckedNodes();
              let departmentList = [];
              this.departmentList.forEach(item=>{
                if(item.guid!='ALL'){
                  departmentList.push(item)
                }
              })
              this.departmentList = departmentList
            });
            this.flag = true;
          } else {
            self.$message.error(res.data.msg);
          }
        })
    },
    //获取组织
    getOrganisation2() {
      let self = this;
      let guids = this.belongStaffGuidList.map(item=>item.guid);
      self.api
        .postJson(`/${serverConfig.msCustomerService}/tenant-expand/data/get-tenant-tag-tree`,guids)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data
            if(!self.areaData) return this.$message.error('暂无可选任务执行人，请检查项目运营人员')
            if (self.areaData.length > 0) {
              self.areaData.unshift({
                desc: 'ALL',
                key: 'ALL',
                parentKey: 'ALL',
                name: '全选'
              })
            }

            this.$nextTick(() => { // 返显用
              
              if(this.personGuidList.length==this.areaData.length-1){
                this.personGuidList.push('ALL');
              }
              let selectNodeKey = sessionStorage.getItem('selectNode') ? (JSON.parse(sessionStorage.getItem('selectNode'))).map(item=>item.parentKey) : []
              this.$refs.treeDep.setCheckedKeys(selectNodeKey);
              this.departmentList = this.$refs.treeDep.getCheckedNodes();
              let departmentList = [];
              this.departmentList.forEach(item=>{
                if(item.key!='ALL'){
                  departmentList.push(item)
                }
              })
              this.departmentList = departmentList
            });
            this.flag = true;
          } else {
            self.$message.error(res.data.msg);
          }
        })
    },
    // 获取公司人员
    getNumPeople(tenantGuidList,callBack) {
      let tenantObj = {}
      let param = {
        "memberStatus": "ZSHY",
        "searchCode": "A001",
        tenantGuidList : tenantGuidList
      }
      this.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/get-all-send-tenant-simple-info`,param)
        .then(res=>{
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.departmentTableData = res.data.data || [];
            this.departmentList.forEach(A=>{
              this.departmentTableData.forEach(B=>{
                if (A.key === B.guid) {
                  B.tenantTag = A.name
                }
             })
            })
            this.departmentTableData = [...this.departmentTableData]
            if (callBack)callBack(list)
          }
        })
    },

    //部门弹框选择
    handleNodeClickPerson(data, checked, node) {
      if (data.key == 'ALL' && checked) {
        let allList = JSON.parse(JSON.stringify(this.areaData));
        let personGuidList = [];
        allList.forEach(item => { personGuidList.push(item.key) })
        this.$refs.treeDep.setCheckedKeys(personGuidList);
      }
      if (data.key == 'ALL' && !checked) {
        this.clearNode()
        return
      }
      this.departmentList = this.getCheckedNodes()
    },
    clearNode() {
      let node = this.$refs.treeDep.getNode(this.areaData[0].parentKey).parent;
      // 然后便历树，将所有的checked改成false
      this.clearChecked(node.childNodes)
    },
    clearChecked(childNodes) {
      if (Array.isArray(childNodes) && childNodes.length) {
        childNodes.forEach(item=>{
          item.checked = false
          if (Array.isArray(item.childNodes) && item.childNodes.length) {
            this.clearChecked(item.childNodes)
          }
        })
      }
    },
    // 获取根节点
    getCheckedNodes() {
     return this.$refs.treeDep.getCheckedNodes().filter(item=>!item.child && item.key !== 'ALL')
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //确定选择部门
    departmentSure() {
      
      // this.departmentList.forEach(item=>item.guid = item.key) 
      this.$emit('onSelect', [this.personGuidList, this.departmentTableData]);
      this.visible = false;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选数据！');
        return;
      }
      let departmentTableData = JSON.parse(JSON.stringify(this.departmentTableData)); // 拿到右侧勾选的
      
      let selectNode = sessionStorage.getItem('selectNode') ? JSON.parse(sessionStorage.getItem('selectNode')): [] // 删除缓存的勾选
      this.departmentTableData =  departmentTableData.filter(item => this.delList.every(one => one.guid !== item.guid)); // 匹配剩余的
      let newSelectNode = selectNode.filter(item => this.delList.every(one => one.guid !== item.key)); // 匹配剩余的
      sessionStorage.setItem('selectNode',JSON.stringify(newSelectNode))
    },

    handleSelectionChangeDel(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
  },
};
</script>

<style scoped>
/* // !tree样式优化 */
/* /deep/.el-tree-node__expand-icon.is-leaf{
 display: none;
} */
/* 选择人员弹框 */
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}
/deep/ .custom-tree-node{
  display: flex;
}
</style>
